import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const componentGroupConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default componentGroupConfig;
